function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "StatusIcon_Not_Relevant_",
  transform: "translate(-14 -19.794)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5759",
  transform: "translate(14 19.794)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Reject",
  d: "M13.654,7.347a.85.85,0,0,0-1.207,0L10.5,9.3,8.554,7.347A.854.854,0,0,0,7.347,8.554L9.3,10.5,7.347,12.447a.854.854,0,1,0,1.207,1.207L10.5,11.7l1.947,1.955a.854.854,0,1,0,1.207-1.207L11.7,10.5l1.955-1.947a.85.85,0,0,0,0-1.207ZM16.51,4.491a8.5,8.5,0,1,0,0,12.021,8.5,8.5,0,0,0,0-12.021Zm-1.2,10.821A6.8,6.8,0,1,1,17.3,10.5,6.8,6.8,0,0,1,15.311,15.311Z",
  transform: "translate(16 20.794)",
  fill: "currentColor"
}));

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.a51e2b04.svg";
export { ForwardRef as ReactComponent };